import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_3 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_4 = {
  key: 2,
  class: "tab-content"
}
const _hoisted_5 = {
  key: 3,
  class: "tab-content"
}
const _hoisted_6 = {
  key: 4,
  class: "tab-content"
}
const _hoisted_7 = {
  key: 5,
  class: "tab-content"
}
const _hoisted_8 = {
  key: 6,
  class: "tab-content"
}
const _hoisted_9 = {
  key: 7,
  class: "tab-content"
}
const _hoisted_10 = {
  key: 8,
  class: "tab-content"
}
const _hoisted_11 = {
  key: 9,
  class: "tab-content"
}
const _hoisted_12 = {
  key: 10,
  class: "tab-content"
}
const _hoisted_13 = {
  key: 11,
  class: "tab-content"
}
const _hoisted_14 = {
  key: 12,
  class: "tab-content"
}
const _hoisted_15 = {
  key: 13,
  class: "tab-content"
}
const _hoisted_16 = {
  key: 14,
  class: "tab-content"
}
const _hoisted_17 = {
  key: 15,
  class: "tab-content"
}
const _hoisted_18 = {
  key: 16,
  class: "tab-content"
}
const _hoisted_19 = {
  key: 17,
  class: "tab-content"
}
const _hoisted_20 = {
  key: 18,
  class: "tab-content"
}
const _hoisted_21 = {
  key: 19,
  class: "tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxTabs = _resolveComponent("DxTabs")!
  const _component_GridGrupuriAngajati = _resolveComponent("GridGrupuriAngajati")!
  const _component_GridMeserii = _resolveComponent("GridMeserii")!
  const _component_GridPositions = _resolveComponent("GridPositions")!
  const _component_GridSarbatoriLegale = _resolveComponent("GridSarbatoriLegale")!
  const _component_GridTemeiuriLegale = _resolveComponent("GridTemeiuriLegale")!
  const _component_GridTrepteDeVechime = _resolveComponent("GridTrepteDeVechime")!
  const _component_GridIndemnizatii = _resolveComponent("GridIndemnizatii")!
  const _component_GridTipRetinere = _resolveComponent("GridTipRetinere")!
  const _component_GridStudies = _resolveComponent("GridStudies")!
  const _component_GridTipuriDocIdentitate = _resolveComponent("GridTipuriDocIdentitate")!
  const _component_GridTipuriConcedii = _resolveComponent("GridTipuriConcedii")!
  const _component_GridAtribute = _resolveComponent("GridAtribute")!
  const _component_GridMomenteCalcul = _resolveComponent("GridMomenteCalcul")!
  const _component_GridActivitati = _resolveComponent("GridActivitati")!
  const _component_GridCerinte = _resolveComponent("GridCerinte")!
  const _component_GridGrilaSalarizare = _resolveComponent("GridGrilaSalarizare")!
  const _component_GridStariPosturi = _resolveComponent("GridStariPosturi")!
  const _component_TipuriCereriDocumente = _resolveComponent("TipuriCereriDocumente")!
  const _component_TipuriDocumenteHR = _resolveComponent("TipuriDocumenteHR")!
  const _component_AprobariPortalHR = _resolveComponent("AprobariPortalHR")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxTabs, {
      "data-source": $data.tabs,
      "selected-index": $data.selectedIndex,
      onOptionChanged: $options.onTabChanged,
      orientation: "vertical",
      "item-template": $options.tabTemplate,
      class: "tabs"
    }, null, 8, ["data-source", "selected-index", "onOptionChanged", "item-template"]),
    ($data.selectedIndex===0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_GridGrupuriAngajati)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_GridMeserii)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_GridPositions)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_GridSarbatoriLegale)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_GridTemeiuriLegale)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_GridTrepteDeVechime)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_GridIndemnizatii)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_GridTipRetinere)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_GridStudies)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===9)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_GridTipuriDocIdentitate)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===10)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_GridTipuriConcedii)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===11)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_GridAtribute)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===12)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createVNode(_component_GridMomenteCalcul)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===13)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_GridActivitati)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===14)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_GridCerinte)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===15)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_GridGrilaSalarizare)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===16)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_GridStariPosturi)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===17)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_TipuriCereriDocumente)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===18)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
          _createVNode(_component_TipuriDocumenteHR)
        ]))
      : _createCommentVNode("", true),
    ($data.selectedIndex===19)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_AprobariPortalHR)
        ]))
      : _createCommentVNode("", true)
  ]))
}